import { moment } from 'locale'
import React from 'react'
import { getMomentDate } from 'utils'

interface Props {
  dateCompared?: string
  dateCurrent?: string
}

function RevenueDateDescription({ dateCompared, dateCurrent }: Props) {
  const formattedDateCurrent = dateCurrent && moment(dateCurrent).format('L')
  const formattedDateCompared = getMomentDate(dateCompared).format('L')

  return formattedDateCurrent && formattedDateCurrent !== formattedDateCompared ? (
    <span>
      {formattedDateCompared}, <i className="fm fm-at" /> {formattedDateCurrent}
    </span>
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{formattedDateCompared}</>
  )
}

export default RevenueDateDescription
